import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Box as MuiBox } from '@mui/material';
export const Box = /*#__PURE__*/ forwardRef(function Box({ ...props }, ref) {
    return /*#__PURE__*/ _jsx(MuiBox, {
        ...props,
        ref: ref
    });
});

//# sourceMappingURL=Box.js.map